import AlertInPastModal from './AlertInPastModal';

export default AlertInPastModal;
